import React from "react";
import { TableRow, TableCell, Skeleton } from "@mui/material";

export default function TableSkeleton({ columnsCount = 1, rowsCount = 3 }) {
  const cols = Array.from({ length: columnsCount });
  const rows = Array.from({ length: rowsCount });

  return (
    <>
      {rows.map((_, rowIndex) => (
        <TableRow key={`skeleton-row-${rowIndex}`}>
          {cols.map((__, colIndex) => (
            <TableCell key={`skeleton-cell-${rowIndex}-${colIndex}`} align="center">
              <Skeleton variant="text" width="80%" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}


